/* Copyright (c) 2022, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum LoggingLevel {
    None = -1,
    Error = 1,
    Warning,
    Info,
    Trace,
    Verbose,
    Event
}

// LoggerSettings interface is used to communicate logging related settings to service worker and web worker
export interface LoggerSettings {
    remoteLoggingEnabled: boolean;
    consoleLoggingEnabled: boolean;
    loggingLevel: LoggingLevel;
    remoteLogFunction: Function;
}
